import { ERROR, LOADING } from "../../constants/constant";
import {
  VALIDATE_OTP,
  VALIDATE_OTP_SUCCESS,
  VALIDATE_OTP_FAILED,
  VALIDATE_OTP_RESET
} from "../actions/ActionType";

const initialState = {
  status: "",
  isLoading: true,
};

export default function validateOtpReducer(state = initialState, action) {
  switch (action.type) {
    case VALIDATE_OTP:
      let reqstState = Object.assign({}, state);
      reqstState.isLoading = true;
      reqstState.status = LOADING;
      return reqstState;

    case VALIDATE_OTP_SUCCESS:
      let userRes = Object.assign({}, state);
      console.log("Otp validated: ", action);
      try {
        userRes.status = action.data.status
        userRes.message = action.data.message;
        userRes.isLoading = false;
        return userRes;
      } catch (error) {
        throw new Error(error);
      }

    case VALIDATE_OTP_FAILED:
      {
        let userRes = Object.assign({}, state, action.data);
        userRes.status = ERROR
        // console.log("Error while validating otp", action.data.data);
        if(action.data.data)
        {
            userRes.status = action.data.data.status;
          userRes.statusCode = action.data.data.error_code;
          userRes.message = action.data.data.data;
          userRes.errorMessage = action.data.data.message;
          userRes.error_reason = action.data.data.error_reason;
        }
        userRes.HTTPStatus=action.data.status;
        userRes.isLoading = false;
        userRes.error = true;
        return userRes;
      }
    

    case VALIDATE_OTP_RESET:
      return initialState;

    default:
      return state;
  }
}